import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxLabel, CircleCheckboxWrapper, FilterWrapper } from './styled';

const Filter = ({ id, checked, active, style, title, handleFilterClick, isDesktop, noTopPadding }) => {
  const shouldBeActive = checked || active;

  return (
    <FilterWrapper
      active={shouldBeActive}
      data-cy={`filter-element-${title.replace(/\s/g, '')}`}
      onClick={() => shouldBeActive && handleFilterClick(checked ? null : id, checked ? null : title)}
      isDesktop={isDesktop}
      firstElem={noTopPadding}
      style={style}
    >
      <CircleCheckboxWrapper data-cy-checked={checked} data-cy-active={active} active={active} checked={checked} />
      <CheckboxLabel active={shouldBeActive}>{title}</CheckboxLabel>
    </FilterWrapper>
  );
};
Filter.propTypes = {
  active: PropTypes.bool,
  checked: PropTypes.bool,
  noTopPadding: PropTypes.bool,
  handleFilterClick: PropTypes.func,
  id: PropTypes.string,
  isDesktop: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string,
  weight: PropTypes.number
};

export default Filter;
